import { graphql } from 'src/graphql';

import {
  TaskBlock,
  TaskBlockCardSort,
  TaskBlockFigmaPrototype,
  TaskBlockLiveWebsiteTest,
  TaskBlockMatrix,
  TaskBlockSystemUsabilityScale,
  TaskBlockMultipleChoiceQuestion,
  TaskBlockOpenAnswer,
  TaskBlockOpinionScale,
  TaskBlockStackRank,
} from 'containers/Studies/data/fragments/UnmoderatedTaskBlock.fragment';

export const CreateUnmoderatedBooking = graphql(
  `
    mutation createUnmoderatedBooking($input: CreateUnmoderatedBookingInput!) {
      createUnmoderatedBooking(input: $input) {
        _id
        name
        type
        status
        config {
          unmoderated {
            welcome_block {
              type
              title
              instructions
            }
            thank_you_block {
              type
              title
              instructions
            }
            task_blocks {
              ...TaskBlock
              ...TaskBlockCardSort
              ...TaskBlockFigmaPrototype
              ...TaskBlockLiveWebsiteTest
              ...TaskBlockMatrix
              ...TaskBlockSystemUsabilityScale
              ...TaskBlockMultipleChoiceQuestion
              ...TaskBlockOpenAnswer
              ...TaskBlockOpinionScale
              ...TaskBlockStackRank
            }
          }
        }
      }
    }
  `,
  [
    TaskBlock,
    TaskBlockCardSort,
    TaskBlockFigmaPrototype,
    TaskBlockLiveWebsiteTest,
    TaskBlockMatrix,
    TaskBlockSystemUsabilityScale,
    TaskBlockMultipleChoiceQuestion,
    TaskBlockOpenAnswer,
    TaskBlockOpinionScale,
    TaskBlockStackRank,
  ],
);
